module.exports = __webpack_public_path__ + "img/offers6.eee7e00d.jpg";